var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96",
    overflow: "visible",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Den Technologies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FFC400",
    points: "37.2,22.5 55,25.4 58.1,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FF9400",
    points: "46.1,34.5 55,25.4 37.2,22.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FF6200",
    points: "55,25.4 62.2,55.2 46.1,34.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FF9400",
    points: "55,25.4 62.2,55.2 65.6,36.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#ED0001",
    points: "46.1,34.5 49.2,50.2 25.6,55.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FF9400",
    points: "49.2,50.2 70.4,65.8 46.1,34.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FF6200",
    points: "54.5,65.6 49.2,50.2 61.2,59.1 70.4,65.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#ED0001",
    points: "70.4,65.8 64.8,78.3 42.5,85.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#FF6200",
    points: "42.5,85.8 25.6,55.7 49.2,50.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#ED0001",
    points: "49.2,50.2 42.5,85.8 54.5,65.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#B80C0A",
    points: "42.5,85.8 54.5,65.6 70.4,65.8  "
  }))));
};
export default SvgLogoNoText;